// Rowan University's undergraduate majors (#2743). Read on 2026-10-01 from
// the official 2026-2027 Academic Catalog (catalog.rowan.edu, catoid=18): the
// Programs of Study page's "Bachelor" list (111 programs), each placed under
// the college or school whose catalog page lists it. Left out: minors,
// concentrations, certificates, accelerated dual degrees, graduate programs,
// the RN to BSN and Respiratory Therapy (Degree Advancement) programs (for
// students already licensed). The catalog writes degrees in full ("Bachelor
// of Arts in Advertising"), so the degree field keeps the full name; the
// education majors drop the catalog's "Education:" prefix ("Bachelor of Arts
// in Education: Art Education" is "Art Education"). The KB's majors list was
// the starting point; the catalog wins.
const majors = {
    "slug": "rowan-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Rowan's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, concentrations, certificates, accelerated dual degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Education",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, College of Education",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1677"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Elementary Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Health & Physical Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Inclusive Elementary & Special Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Leadership & Social Innovation",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Literacy Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish Education",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Science & Mathematics",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, College of Science & Mathematics",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1681"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biophysics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computing & Informatics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Molecular & Cellular Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Psychological Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Translational Biomedical Sciences",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of the Arts",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, College of the Arts",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1679"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Industry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Studio Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Henry M. Rowan College of Engineering",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, Henry M. Rowan College of Engineering",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1678"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Construction Management",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Electrical & Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Engineering Entrepreneurship",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Engineering Technology Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Surveying Engineering Technology",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Ric Edelman College of Communication, Humanities & Social Sciences",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, Ric Edelman College of Communication, Humanities & Social Sciences",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1680"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Africana Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Applied Professional Communication",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Area Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biomedical Visualization",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Disaster Preparedness & Emergency Management",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Esports",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "General Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Health & Science Communication",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Human Services",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "International Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Law & Justice Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Modern Languages & Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Relations",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Radio, Television, & Film",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sports Communication & Media",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "World Religions",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Writing Arts",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Rita & Larry Salva School of Nursing & Health Professions",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, Rita & Larry Salva School of Nursing & Health Professions",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1683"
            },
            "majors": [
                {
                    "name": "Athletic Training Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Exercise Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Fitness Management",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Health Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science",
                    "note": "The catalog lists it as the Cooperative Bachelor of Science in Nursing."
                },
                {
                    "name": "Nutrition",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Public Health & Medical Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Public Health & Wellness",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Wellness Management",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "School of Earth & Environment",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, School of Earth & Environment",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1682"
            },
            "majors": [
                {
                    "name": "Community & Environmental Planning",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental & Sustainability Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Innovation & Entrepreneurship",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, School of Innovation & Entrepreneurship",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1675"
            },
            "majors": [
                {
                    "name": "Entrepreneurship",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Professional Studies",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, School of Professional Studies",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1684"
            },
            "majors": [
                {
                    "name": "Healthcare Management & Administration",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "William G. Rohrer College of Business",
            "source": {
                "label": "Rowan University 2026-2027 Academic Catalog, William G. Rohrer College of Business",
                "url": "https://catalog.rowan.edu/content.php?catoid=18&navoid=1674"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Analytics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Information Systems & Analytics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Supply Chain & Logistics",
                    "degree": "Bachelor of Science"
                }
            ]
        }
    ]
};

export default majors;
